import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updateContractBillDetailsSchema = z.object({
  contract: z.object({
    cycle: optionSchema,
    cycle_start_day: z
      .object({
        label: z.string(),
        value: z.string(),
      })
      .optional()
      .refine((value) => value?.value !== undefined, {
        message: 'Campo obrigatório',
      }),
    closing_to_due_in_days: optionSchema,
  }),
})

export type UpdateContractBillDetailsSchema = z.infer<typeof updateContractBillDetailsSchema>
